module.exports = __webpack_public_path__ + "8ab5b7b11e18cf8d4d5127c4e310820d.png";